module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-24.56e158eb.jpg";